module.exports = __webpack_public_path__ + "img/bread_norm.b38071a8.jpg";